import React, { useCallback } from 'react';

import { isEmptyCollection } from '@atlas/core';
import { HeaderTitle } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Casino/CasinoFilterContext';
import { casinoFilterTypeMap, toggleCasinoFilterListItem } from 'components/Casino/useCasinoFilter';

import CasinoInlineFilterItem from './CasinoInlineFilterItem';

const CasinoInlineFilter = () => {
  const {
    filter: { providerNames },
    updateFilter,
  } = useCasinoFilterState();
  const resetFilterItem = useCallback(
    (field, value) => {
      toggleCasinoFilterListItem(field, value);

      const newProviders = () => {
        if (providerNames.includes(value)) {
          return providerNames?.filter(el => el !== value);
        }
        return [...providerNames, value];
      };

      updateFilter({ providerNames: newProviders() });
    },
    [providerNames],
  );

  if (!providerNames || isEmptyCollection(providerNames)) {
    return null;
  }

  return (
    <div className="casino-filtered">
      <HeaderTitle className="casino__title" title="filters">
        :
      </HeaderTitle>
      <div className="casino-filtered__wrapper">
        {providerNames.map(item => (
          <CasinoInlineFilterItem
            changeFilter={resetFilterItem}
            field={casinoFilterTypeMap.providerNames}
            key={item}
            name={item}
            translated
          />
        ))}
      </div>
    </div>
  );
};

export default CasinoInlineFilter;
